import React, { useEffect, useMemo, useState } from "react";
import { Button, Popconfirm, Select, Space, message } from "antd";
import { EditOutlined } from "@ant-design/icons";
import { useAuth0 } from "../../../react-auth0-spa";
import { useAppContext } from "../../../context";
import config from "../../../api_config.json";

// Editable select for organizzazione.recurring_billing_frequency ('month' | 'year')
const FieldRecurringBillingFrequency = ({ org }) => {
  const { getTokenSilently } = useAuth0();
  const { isProd } = useAppContext();

  const [editing, setEditing] = useState(false);
  const initVal = org?.recurring_billing_frequency || null;
  const [value, setValue] = useState(initVal);
  const [originalValue, setOriginalValue] = useState(initVal);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [saving, setSaving] = useState(false);

  const toLabel = (v) => (v === 'month' ? 'Mensile' : v === 'year' ? 'Annuale' : (v || '-'));

  const displayValue = useMemo(() => {
    return toLabel(value || org?.recurring_billing_frequency);
  }, [value, org?.recurring_billing_frequency]);

  const handleConfirm = async () => {
    if (!value) { setConfirmOpen(false); setEditing(false); return; }
    try {
      setSaving(true);
      const token = await getTokenSilently();
      const graphqlUrl = `${config.baseUrl[isProd ? "prod" : "dev"]}/graphql?raw=true`;
      const mutation = `
        mutation UpdateOrganizzazione($id: ID!, $fields: UpdateOrganizzazioneFieldsInput) {
          updateOrganizzazione(input: { id: $id, fields: $fields }) {
            organizzazione { objectId recurring_billing_frequency }
          }
        }
      `.replace(/\r?\n|\r/g, "").replace(/\t/g, " ");

      const body = {
        query: mutation,
        variables: { id: org.objectId, fields: { recurring_billing_frequency: value } },
      };

      const resp = await fetch(graphqlUrl, {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
        body: JSON.stringify(body),
      });
      const json = await resp.json();
      if (json.errors) throw new Error(json.errors[0]?.message || "GraphQL error");

      message.success("Fatto");
      setOriginalValue(value);
      setConfirmOpen(false);
      setEditing(false);
    } catch (e) {
      console.error("Errore aggiornamento recurring_billing_frequency:", e);
      message.error("Si è verificato un problema: " + e.message);
    } finally {
      setSaving(false);
    }
  };

  const handleCancelAll = () => {
    setValue(originalValue);
    setConfirmOpen(false);
    setEditing(false);
  };

  useEffect(() => {
    const v = org?.recurring_billing_frequency || null;
    setValue(v);
    setOriginalValue(v);
  }, [org?.recurring_billing_frequency]);

  return (
    <>
      {!editing && (
        <Space size="small">
          <span>{displayValue}</span>
          <Button size="small" type="link" icon={<EditOutlined />} onClick={() => setEditing(true)}>
            Modifica
          </Button>
        </Space>
      )}
      {editing && (
        <Space size="small">
          <Popconfirm
            title="Sei sicuro di voler aggiornare la org?"
            open={confirmOpen}
            okButtonProps={{ loading: saving }}
            onConfirm={handleConfirm}
            onCancel={() => { setConfirmOpen(false); setEditing(false); }}
          >
            <Select
              size="small"
              style={{ minWidth: 160 }}
              value={value}
              onChange={(v) => { setValue(v); setConfirmOpen(true); }}
              options={[
                { value: 'month', label: 'Mensile' },
                { value: 'year', label: 'Annuale' },
              ]}
            />
          </Popconfirm>
          <Button size="small" onClick={handleCancelAll}>Annulla</Button>
        </Space>
      )}
    </>
  );
};

export default FieldRecurringBillingFrequency;
